<template>
  <div class="header">
    <a href="https://www.gstarcad.net/Eshop">
      <img src="../../static/images/header-logo.png" alt />
    </a>
    <ul>
      <li>
        <a
          href="javascript:void(0);"
          :class="currentPath===$t('header.home')?'active':''"
          @click="handleSelect('/',fastUrld,$event)"
        >{{$t('header.home')}}</a>
      </li>
      <li>
        <a
          href="javascript:void(0);"
          :class="currentPath===$t('header.d3Fastview')?'active':''"
          @click="handleSelect('/','',$event)"
        >{{$t('header.d3Fastview')}}</a>
      </li>
      <li>
        <a
          href="javascript:void(0);"
          :class="currentPath===$t('header.features')?'active':''"
          @click="handleSelect('/features','',$event)"
        >{{$t('header.features')}}</a>
      </li>
      <li>
        <a
          href="javascript:void(0);"
          :class="currentPath===$t('header.support')?'active':''"
          @click="handleSelect('/support/index','',$event)"
        >{{$t('header.support')}}</a>
      </li>
      <li>
        <a
          href="javascript:void(0);"
          :class="currentPath===$t('header.reviews')?'active':''"
          @click="handleSelect('/reviews','',$event)"
        >{{$t('header.reviews')}}</a>
      </li>
      <li>
        <a
          href="javascript:void(0);"
          :class="currentPath===$t('header.case')?'active':''"
          @click="handleSelect('/case','',$event)"
        >{{$t('header.case')}}</a>
      </li>
    </ul>
    <div class="header-btn-box">
      <button id="header-btn-download" @click="toShow">{{$t('header.download')}}</button>
      <div id="header-btn-line"></div>
      <button id="header-btn-buy" @click="handleSelect('/buy','',$event)">{{$t('header.buy')}}</button>
    </div>

    <el-dropdown class="header-caidan">
      <span class="el-dropdown-link icon iconfont viewcaidan">
        <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :class="currentPath===$t('header.home')?'active-down':''">
          <a href="javascript:void(0);" @click="handleSelect('/',fastUrld,$event)">{{$t('header.home')}}</a>
        </el-dropdown-item>
        <el-dropdown-item :class="currentPath===$t('header.d3Fastview')?'active-down':''">
          <a
            href="javascript:void(0);"
            @click="handleSelect('/','',$event)"
          >{{$t('header.d3Fastview')}}</a>
        </el-dropdown-item>
        <el-dropdown-item :class="currentPath===$t('header.features')?'active-down':''">
          <a
            href="javascript:void(0);"
            @click="handleSelect('/features','',$event)"
          >{{$t('header.features')}}</a>
        </el-dropdown-item>
        <el-dropdown-item :class="currentPath===$t('header.support')?'active-down':''">
          <a href="javascript:void(0);" @click="handleSelect('/support/index','',$event)">{{$t('header.support')}}</a>
        </el-dropdown-item>
        <el-dropdown-item :class="currentPath===$t('header.reviews')?'active-down':''">
          <a
            href="javascript:void(0);"
            @click="handleSelect('/reviews','',$event)"
          >{{$t('header.reviews')}}</a>
        </el-dropdown-item>
        <el-dropdown-item :class="currentPath===$t('header.case')?'active-down':''">
          <a href="javascript:void(0);" @click="handleSelect('/case','',$event)">{{$t('header.case')}}</a>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- <span class="icon iconfont viewcaidan"></span> -->
  </div>
</template>


<script>
import {fastUrl} from "../../config/build-config"
export default {
  data() {
    return {
      currentPath: "",
      fastUrld:''
    };
  },
  methods: {
    handleSelect(path, type,event) {
      if(type){
        window.location.href=type
      }else{
      this.$router.replace(path);
      }
      this.currentPath = event.srcElement.innerText;
    },
    selectPath(path) {
      this.currentPath = path;
    },
    toPath(path) {
      this.$router.push(path);
    },
    toShow() {
      console.log(this.$parent.showDialog());
    }
  },
  mounted() {
    // this.$i18n.locale ="en"
    this.fastUrld = fastUrl
  }
};
</script>

<style lang="scss">
@import "../../static/css/header.scss";
</style>





// WEBPACK FOOTER //
// src/components/HeadBar.vue